import { render, staticRenderFns } from "./CaptionText.vue?vue&type=template&id=0ff878ec&scoped=true"
import script from "./CaptionText.vue?vue&type=script&lang=ts"
export * from "./CaptionText.vue?vue&type=script&lang=ts"
import style0 from "./CaptionText.vue?vue&type=style&index=0&id=0ff878ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff878ec",
  null
  
)

export default component.exports